<template>
  <md-layout md-column md-gutter>
    <md-toolbar class="md-transparent">
      <img src="../assets/Insilico_logo.svg" class="top_logo"/>

      <h2 class="md-title" style="flex: 1">&nbsp;</h2>
      <ul class="top_menu">
        <li><a href="#" v-scroll-to="'#about'">About</a></li>
        <li><a href="#"  v-scroll-to="'#contacts'">Contacts</a></li>
        <li><a href="#"  v-scroll-to="'#login'">Login</a></li>
      </ul>
    </md-toolbar>
    
    <md-layout class="main_img">
     
    </md-layout>
    <md-layout class="how_it_works"  md-align="center">
      <h2>How it works</h2>
    </md-layout>
    
    <md-layout  md-align="center" md-gutter>
       
	    <md-layout md-flex="15" md-align="center" md-column class="how_box" >
	      <div class="how_box_icon icon1" ></div>
	      <div class="how_box_header">REGISTER</div>
	      <div class="how_box_text">Enter some information about your experience in medicinal chemistry for further analysis</div>
	    </md-layout>
	    <md-layout md-flex="15" md-align="center" md-column  class="how_box">
	      <div class="how_box_icon icon2" ></div>
	      <div class="how_box_header">SELECT TEST</div>
	      <div class="how_box_text">Select a type of the experiment to run:<br/>
                                    - using EMOTIV device<br/>
                                    - or without it</div>
	    </md-layout>
	    <md-layout md-flex="15" md-align="center" md-column class="how_box">
	      <div class="how_box_icon icon3" ></div>
	      <div class="how_box_header">TAKE THE TEST</div>
	      <div class="how_box_text">Look at the molecules and Like/Dislike or Look at the molecules and guess if the molecule is designed by the GAN or another medicinal chemistct</div>
	    </md-layout>
	    <md-layout md-flex="15" md-align="center" md-column  class="how_box">
	      <div class="how_box_icon icon4" ></div>
	      <div class="how_box_header">GET A REPORT</div>
	      <div class="how_box_text">We are working on immediate reporting You will get a comprehensive report after several medicinal chemists join the experiment</div>
	    </md-layout>
	    
    </md-layout>
    
    <md-layout  md-align="center" class="l_what_is" id="about">
      <md-layout md-flex="45"  md-column class="what_is_container">
        <md-toolbar class="md-transparent" style="padding: 30px;">
          <h2 class="md-title" style="flex: 1">WHAT IS CHEMISTRY.AI </h2>
         <md-button class="md-fab md-mini open-button" @click="show_what_is = !show_what_is" >
           <md-icon v-if="show_what_is">close</md-icon>
           <md-icon v-else >add</md-icon>
         </md-button>
       </md-toolbar>
       
       <transition name="slide-fade">
       <md-layout class="l_about" v-show="show_what_is">
 
          <p>
     		Medicinal chemistry is among one of the most important and intellectually-challenging professions on the planet. It takes decades of training and experience to learn the properties of the thousands of molecules and their effects on the biological systems, model organisms and diseases. Decisions made by the medicinal chemists affect the lives of billions of people and may result in the billions of dollars of gains or losses by the pharmaceutical companies. 
          </p><p>
          Experienced medicinal chemists have the ability to accurately describe the properties and the possible effects of the molecule just by looking at its structure as well as at the various numerical parameters. 
		</p><p>
		Medicinal chemists may like or dislike certain molecular structures because of their experience with the hundreds or thousands of molecules they encountered previously and the emotional response to the molecule is usually biased and related to the molecules and the classes of molecules they are most familiar with. 
		</p><p>
		Chemistry.AI will provide a platform for the medicinal chemists to look at the various classes of molecules and measure their brain activity and other physiological parameters during the exposure to the molecule. 
		</p><p>
		The system is intended to answer the following questions: 
 		</p>
 		<ol>
		<li> Can a medicinal chemist have a ”hunch” about the good or bad molecule?</li>

		<li>Can a medicinal chemist predict the outcome of a clinical trial by just looking at the molecule? </li>

		<li> Can we create a test to compare medicinal chemists using 1 & 2 questions?</li>

		<li> Can the medicinal chemist distinguish the molecules created by the human medicinal chemists from those generated by artificial intelligence (A.I.)</li>

		<li> Can we use the top-performing medicinal chemists as discriminators for training the deep neural networks?</li>

		<li> Can we pinpoint the are a of the brain responsible for recognizing the good molecules?</li>
 
 
 		</ol>  
   
   		</p>
        
        </md-layout>
        </transition>
       
       
     </md-layout>
   </md-layout>
   
   <md-layout  md-align="center" id="login">
   <md-layout md-flex="70" class="user_form_container" >
      <user-form class="userf"></user-form>
   </md-layout>
   </md-layout>
  
  
  <md-layout  class="footer" id="contacts">
    <md-layout md-flex="20" md-flex-offset="20">
      <strong>Insilico Medicine, Inc.</strong> 
      Emerging Technology Centers <br/>
      Johns Hopkins University Eastern Campus <br/>
      Suite B301, 1101 East 33rd St.<br/>
      Baltimore, MD 21218<br/><br/>

     Phone: +1 443 451 7212<br/>
     Fax: +1 443 451 7210<br/><br/>

     Email: zhu(at)insilicomedicine.com<br/>
    
    
    </md-layout>
  
  </md-layout>
  
  </md-layout>
</template>

<script>
import UserForm from './UserForm'

export default{
	name: 'testpage',
	props: [],
	components: {
	      UserForm
	    },
	data(){
		return {
			show_what_is: false
			
		}
	},
	created() {
		
    },
	computed: {
		
	},
	methods: {
		ttt() {
			console.log('clicked')
		}
		
		
	}
}
</script>

<style scoped>
.top_logo {
    max-width: 80px; 
    width: 80px;
    height: auto;
    display: block;
    margin: 0 0 0 32px;
}
.top_menu {
     list-style:none;
}
.top_menu li {
    display: inline;
    font-size: 16px;
    color: #000;
    padding: 0 15px;
}
.top_menu li a {
    color:#6e6e6e;
    font-weight:600;
}
.top_menu li a:hover {
    text-decoration: none;
    color: #000;
}
.main_img {
    height: 100vh;
    background-image: url('../assets/quentin_robot_2_logo.png');
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    
    position: relative;
    overflow: hidden;
    background-attachment: scroll;
    

}
.how_it_works{
    margin-bottom: 105px;
}
.how_it_works h2 {
    color:#eb8d00;
    font-size: 42px;
    line-height: 1.23;
}
.how_box {
    margin: 0 20px;
}
.how_box_icon{
    width: 100px;
    height: 100px;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    margin: 0 auto;
}
.icon1 {
    background-image: url('../assets/icon1.svg');
}
.icon2 {
    background-image: url('../assets/icon2.svg');
}
.icon3 {
    background-image: url('../assets/icon3.svg');
}
.icon4 {
    background-image: url('../assets/icon4.svg');
}
.how_box_header {
    color: #f27705;
    margin-top: 15px ;
    text-align: center;
    font-size: 1vw;
    line-height: 1.35;
    font-weight: 600;
}
.how_box_text{
    text-align: center;
    margin-top: 15px;
    font-size: .8vw;
    font-weight: 300;
    line-height: 1.55;
}
.l_what_is {
    margin: 45px 0 0 0;
    
}
.what_is_container {
    background-color: #e36600;
    color: #fff;
    
    height: auto;
    
}
.open-button {
    background-color: #e36600 !important;
}
.open-button:hover {
    background-color: #fff !important;
}
.what_is_container h2 {
    color: #fff;
    font-size: 2vw;
    font-weight: 600;
    
}
.l_about {
    margin: 0;
    padding: 0 30px 30px 30px;
    font-size: .9vw;
    line-height: 1.55;
}
.footer {
    padding-top: 30px;
    background-color: #c4c4c4;
    font-size: 18px;
    line-height: 1.55;
}

.slide-fade-enter-active {
  transition: all .3s ease;
}
.slide-fade-leave-active {
  transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active до версии 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
</style>


// WEBPACK FOOTER //
// TestPage.vue?60cdbb54